module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEzIDEwIj4KICAgIDxwYXRoIGZpbGw9IiNjYWY0ZmMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcuMyA4LjkzM0wxMi44IDEuNkExIDEgMCAwIDAgMTIgMEgxYTEgMSAwIDAgMC0uOCAxLjZsNS41IDcuMzMzYTEgMSAwIDAgMCAxLjYgMHoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./components/atoms/Icon/icons/triangle.svg
// module id = 1758
// module chunks = 0